import type { DownloadTreeNode } from '~/types/download'
import { computed } from 'vue'

function isNodeSelectable(node: DownloadTreeNode) {
  if (node.selectable !== undefined) {
    return node.selectable
  }
  return Boolean(node.ezMainNodeId)
}

export function useDownloadNode(tocItem: DownloadTreeNode, level: number, renderLeafNodes: boolean, noAvailabilityLabel?: string) {
  const isSelectable = computed(() => isNodeSelectable(tocItem))
  const isUnavailable = computed(() => !isSelectable.value)

  const children = computed(() => tocItem.children ?? [])
  const hasChildren = computed(() => children.value.length > 0)

  const hasRenderableChildren = computed(() => {
    if (!hasChildren.value) {
      return false
    }

    if (renderLeafNodes) {
      return true
    }

    return children.value.some(tocItem => Array.isArray(tocItem?.children) && tocItem.children.length > 0)
  })

  const shouldRenderNode = computed(() =>
    renderLeafNodes || hasChildren.value || level === 0,
  )

  const availabilityAppendix = computed(() => {
    const label = noAvailabilityLabel
    if (!isUnavailable.value || !label) {
      return ''
    }
    const title = (tocItem.title ?? '').trim()
    if (!title) {
      return label
    }
    const endsWithDot = title.endsWith('.')
    return `${endsWithDot ? ' ' : '. '}${label}`
  })

  return { isUnavailable, children, hasRenderableChildren, shouldRenderNode, availabilityAppendix }
}
